<!-- Admin Data Source Picker Builder -->

<template>
	<div class="bld-adm-ds">
		<div class="title wi8_font">Admin Data Source Builder</div>

		<div class="content">
			<AdmDataSource />
		</div>

	</div>
</template>

<script>
export default {

}
</script>

<style scoped>
.bld-adm-ds {
	height: 100%;
	background-color: #FCFCEE;
	border: solid 0px #C30;
}

.title {
	height: 30px;
	color: #36C;
	border: solid 0px #369;
}

.content {
	height: calc(100% - 30px);
	border: solid 0px #090;
}
</style>
